import { V2Drawer } from '@abyss/web/ui/Drawer';
import { Markdown } from '@abyss/web/ui/Markdown';

const InformationalDrawerStyling = {
  'abyss-modal-base-body': {
    fontFamily: 'AbyssEnterpriseSansVF',
  },
};

export const InformationalDrawer = ({
  header,
  content,
  isDrawerOpen,
  setIsDrawerOpen,
}: {
  header: string;
  content: string;
  isDrawerOpen: boolean;
  setIsDrawerOpen: (isOpen: boolean) => void;
}) => {
  const handleOnClose = () => {
    setIsDrawerOpen(false);
  };
  return (
    <V2Drawer
      css={InformationalDrawerStyling}
      data-testid="informational-drawer"
      header={header}
      isOpen={isDrawerOpen}
      onClose={handleOnClose}
      position="right"
      size="$sm"
    >
      <Markdown>{content}</Markdown>
    </V2Drawer>
  );
};
